// extracted by mini-css-extract-plugin
export default {"todoWrapper":"todoContainer_todoWrapper__u5qXG","todoListWrapper":"todoContainer_todoListWrapper__O1-2T"};